@use '@lib/assets/styles/main.scss' as *;
.list {
  margin: 0 auto;
  display: flex;
  width: 360px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  list-style: none;

  & > li {
    padding: 0 0 0 24px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 7.5px;
      left: 9px;
      border-radius: 50%;
      background: $gray900;
      width: 6px;
      height: 6px;
    }
  }
}
